import { Menu as AntMenu } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';

export const MenuLink = styled(Link)`
  svg {
    transition: width 0.2s ease-in;
  }
  &:focus {
    outline: 0;
  }
  &:hover {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const MenuItem = styled(AntMenu.Item)`
  & ${MenuLink} {
    color: var(--side-nav-text);
    min-width: 32px;
    margin-left: -8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-05);
    height: 100%;
  }
`;
export const SubMenuItem = styled(MenuItem)`
  --item-hover-bg: var(--gray-80);
  margin: 0;
  min-width: 240px;
  &:first-child {
    margin-top: var(--spacing-05);
  }
  &:not(:last-child) {
    margin-bottom: 0;
  }
  &:last-child {
    margin-bottom: var(--spacing-05);
  }
  &.ant-menu-item-selected {
    box-shadow: none;
    border-right: var(--brand-color) 3px solid;
    background-color: var(--gray-80);
    &:hover {
      background-color: var(--item-hover-bg);
    }
  }
  & ${MenuLink} {
    color: var(--white-100);
    margin-left: 0px;
    ${BodyShort01};
  }
  &:hover {
    background-color: var(--item-hover-bg);
  }
`;

export const Menu = styled(AntMenu)`
  background: inherit;
  &.ant-menu-vertical {
    border-right: none;
    .ant-menu-submenu-title {
      padding-right: unset;
      &:active {
        color: inherit;
        background-color: inherit;
      }
    }
  }
  .ant-menu-submenu {
    color: var(--side-nav-text);
    &.ant-menu-submenu-open {
      color: var(--side-nav-text);
    }
  }
  .ant-menu-submenu-arrow {
    display: none;
  }
  .ant-menu-item {
    &:active {
      color: inherit;
      background-color: inherit;
    }
  }
  ${MenuItem}.ant-menu-item-selected {
    background-color: transparent;
    box-shadow: var(--brand-color) 4px 0 0 inset;
  }
`;
export const SubMenu = styled(Menu.SubMenu)`
  margin-top: var(--spacing-02);
  margin-bottom: var(--spacing-03);
  &:last-child {
    margin-bottom: var(--spacing-02);
  }
  &.ant-menu-submenu-selected {
    background-color: transparent;
    box-shadow: var(--brand-color) 4px 0 0 inset;
  }
  .ant-menu-submenu-title {
    margin: 0;
    svg {
      margin-right: 0px;
      transition: width 0.2s ease-in;
    }
    &:hover {
      color: var(--side-nav-text);
      svg:first-child {
        width: 20px;
        height: 20px;
      }
    }
    &:active {
      color: inherit;
      background-color: inherit;
    }
  }
`;
